import gql from 'graphql-tag';

const modifyEnrollmentMutation = gql`
  mutation updateSubscription(
    $modifyEnrollmentInput: UpdateSubscriptionMutationInput!
  ) {
    updateSubscription(input: $modifyEnrollmentInput) {
      success
      errors
    }
  }
`;

export default modifyEnrollmentMutation;
